import { Injectable } from "@angular/core";

export type NavParamsData = { [key: string]: unknown };

@Injectable({
  providedIn: "root",
})
export class NavParamsService {
  destn: NavParamsData = {};
  constructor() {}

  public set(destn: NavParamsData) {
    this.destn = destn;
  }

  public get(key = ""): NavParamsData | any {
    if (key === "") {
      return this.destn;
    } else {
      return this.destn[key];
    }
  }
}
